import { EventCategory, InstalledBaseEventListFilter } from "../codegen/graphql";

// Changelog entries (IBM-1062) are not shown yet: without a category chosen by the user,
// the event lists stay on the categories they always showed. An allow list instead of
// `notIn: [CHANGELOG]`, which backends without that enum value reject.
export const VISIBLE_EVENT_CATEGORIES = [EventCategory.LIFECYCLE, EventCategory.AUDIT_LOG];

export const withVisibleEventCategories = (
    filter: InstalledBaseEventListFilter
): InstalledBaseEventListFilter => {
    if (filter.eventCategory?.in?.length || filter.eventCategory?.equals) return filter;
    return { ...filter, eventCategory: { ...filter.eventCategory, in: VISIBLE_EVENT_CATEGORIES } };
};

const CHANGELOG_FILTER_FIELDS = ["eventCategory", "eventType"];

/** Drops the changelog options (category and event types) from the event list filter TDAs. */
export const withoutChangelogFilterOptions = <A extends { index: string; optionValues?: { value: string }[] | null }>(
    attributes: A[]
): A[] =>
    attributes.map((attribute) =>
        CHANGELOG_FILTER_FIELDS.includes(attribute.index) && attribute.optionValues
            ? { ...attribute, optionValues: attribute.optionValues.filter((option) => !String(option.value).startsWith("CHANGELOG")) }
            : attribute
    );
